module.exports = __webpack_public_path__ + "files/99c9f24dd717e50a36d02452c1b33c56.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/open-sans-v13-latin-ext_latin_cyrillic-ext_greek-ext_greek_cyrillic_vietnamese-700.svg
 ** module id = 960
 ** module chunks = 0
 **/